import cn from 'classnames'
import { type ReactNode, useEffect, useRef, useState } from 'react'
import './simpleCarousel.scss'

interface CarouselItem {
  id: number
  content: ReactNode
}

interface SimpleCarouselProps {
  items: CarouselItem[]
  onSlideChange?: (index: number) => void
}

export const SimpleCarousel = ({ items, onSlideChange }: SimpleCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const changeSlide = (newIndex: number) => {
    if (newIndex === currentIndex) return

    if (timerRef.current) clearTimeout(timerRef.current)
    setCurrentIndex(newIndex)
  }

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)

    timerRef.current = setTimeout(() => {
      setCurrentIndex(prev => (prev === items.length - 1 ? 0 : prev + 1))
    }, 4000)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [currentIndex, items.length])

  useEffect(() => {
    onSlideChange?.(currentIndex)
  }, [currentIndex, onSlideChange])

  return (
    <div className='simple-carousel'>
      <div className='simple-carousel-slides'>
        {items.map((item, index) => (
          <div
            key={item.id}
            className={cn('simple-carousel-slide', {
              active: index === currentIndex
            })}
          >
            {item.content}
          </div>
        ))}
      </div>

      <div className='simple-carousel-dots'>
        {items.map((item, index) => (
          <button
            key={item.id}
            type='button'
            className={cn('simple-carousel-dot', {
              active: index === currentIndex
            })}
            onClick={() => changeSlide(index)}
          />
        ))}
      </div>
    </div>
  )
}
